<form [formGroup]="frmGetQuote" class="outer-container">
  <section class="quote-fields">
    <div class="left">
      <mat-form-field appearance="standard" floatLabel="always">
        <mat-label>Broker Fee (Mills/{{ utilityUOM$ | async }})</mat-label>
        <input
          id="uplift"
          matInput
          type="number"
          formControlName="upliftDollar"
          (blur)="onChangeBrokerFee($event?.target)"
          (focus)="brokerFeePreviousInput = $event?.target?.value"
        />
        <mat-error *ngIf="areUpliftLimitsSet && isFormInvalid() && frmGetQuote.get('upliftDollar').errors?.required">This field is required</mat-error>
        <mat-error *ngIf="areUpliftLimitsSet && frmGetQuote.get('upliftDollar').errors">Please enter a value between {{ this.upliftMin }} and {{ this.upliftMax }} </mat-error>
      </mat-form-field>
      <span id="gasDollarsPerDekatherm" *ngIf="isGasQuote()" class="upliftMarginMwhLabel"
        >${{ frmGetQuote?.get('upliftDollar')?.value / 100 | number: '1.2-4' }}/{{ (utilityUOM$ | async) === 'therms' ? 'dekatherm' : 'Mcf' }}</span
      >
      <span id="electricDollarsPerMwh" *ngIf="!isGasQuote()" class="upliftMarginMwhLabel"
        >${{ frmGetQuote?.get('upliftDollar')?.value | number: '1.2-4' }}/MWh</span
      >
      

      <mat-form-field *ngIf="pricingSource !== PricingSourceEnum.ManualEntry" appearance="standard" floatLabel="always">
        <mat-label>Agent Fee (Mills/{{ utilityUOM$ | async | lowercase }})</mat-label>
        <input matInput (blur)="onChangeAgentFee($event?.target)"
               (focus)="agentFeePreviousInput = $event?.target?.value"
               type="number" formControlName="agentFee" [disabled]="isButtonQuoteDisabled" />
        <mat-error *ngIf="frmGetQuote.get('agentFee').errors?.required">This field is required</mat-error>
        <mat-error *ngIf="frmGetQuote.get('agentFee').errors">Please enter a value between {{ this.upliftMin }} and {{ this.upliftMax }} </mat-error>
      </mat-form-field>

      

      <!-- The salesManager userRole does not have access to additional margin  -->
      <div *ngIf="user.isSupplierManager && pricingSource !== PricingSourceEnum.ManualEntry">
        <mat-form-field appearance="standard" floatLabel="always">
          <mat-label>Margin (Mills/{{ utilityUOM$ | async }})</mat-label>
          <input matInput type="number" formControlName="marginDollar"
                 (blur)="marginDollarChanges($event?.target)"
                 (focus)="marginDollarPreviousInput = $event?.target?.value"/>
          <mat-error *ngIf="frmGetQuote.get('marginDollar').errors?.required">This field is required</mat-error>
        </mat-form-field>
        <span id="marginDollarsPerMwh" *ngIf="!isGasQuote()" class="upliftMarginMwhLabel">
          ${{ frmGetQuote?.get('marginDollar')?.value | number: '1.2-4' }}/MWh</span
        >
        <span id="marginDollarsPerDekatherm" *ngIf="isGasQuote()" class="upliftMarginMwhLabel"
          >${{ frmGetQuote?.get('marginDollar')?.value / 100 | number: '1.2-4' }}/{{ ((utilityUOM$ | async) === 'therms' ) ? 'dekatherm' : 'Mcf' }}</span
        >
      </div>
      <div *ngIf="isPowwrSupplier">
        <mat-radio-group  formControlName="isTaxIncluded" floatLabel="always" appearance="standard" id="isTaxIncluded">
          <mat-radio-button [value]="true">Include Tax </mat-radio-button>
          <mat-radio-button [value]="false">Exclude Tax </mat-radio-button>
        </mat-radio-group>
      </div>
      <br />

      <div *ngIf="user.isSupplierManagerOrSalesManager">
        <button id="quoteBtn" mat-flat-button color="accent" type="button" (click)="getQuote()" [disabled]="(!this.isQuoteButtonDisabled() ? isButtonQuoteDisabled : this.isQuoteButtonDisabled()) || isReadOnly">
          <img src="/assets/icons/icon-money.svg" class="prefix" />
          <span>{{quote?.prices?.length > 0 ? 'Requote': 'Quote'}}</span>
        </button>
      </div>
      <div *ngIf="!user.isSupplierManagerOrSalesManager">
        <button id="quoteBtn" mat-flat-button color="accent" type="button" (click)="getQuoteDueDateUpdate()" [disabled]="(!this.isQuoteButtonDisabled() ? isButtonQuoteDisabled : this.isQuoteButtonDisabled()) || isReadOnly">
          <img src="/assets/icons/icon-money.svg" class="prefix" />
          <span>{{quote?.prices?.length > 0 ? 'Requote': 'Quote'}}</span>
        </button>
      </div>
      <br>
  
    <app-quote-history-button [quote]="this.quote" [user]="this.user" *ngIf="!quoteStateHelperService.isQuickQuote(this.quoteRequestState)"></app-quote-history-button>

    
      <ng-content select="[quoteSettings]"></ng-content>
    </div>
    <div class="left" style="margin-left:40px;" *ngIf="!user.isSupplierManagerOrSalesManager">
      <p>{{ this.getQuoteExpirationDisclaimer() }}</p>
    </div>
    <div class="right">
      <a (click)="showMoreOrLess(!moreDetails)">
        <ng-container *ngIf="moreDetails; else elseTemplate"> Show Less </ng-container>
        <ng-template #elseTemplate> Show More </ng-template>
      </a>
      <div *ngIf="isPowwrSupplier && user.isSupplierManagerOrSalesManager && this.quote?.prices[0]?.details" id="curveDate">
          Pricing Curve Date - {{ this.pricingCurveDateObs | async | date: 'MM/dd/yyyy' }}
      </div>
      <div id="loadFactor" *ngIf="this.quote?.prices[0]?.details">
        Annual Load Factor: {{ this.annualLoadFactorObs | async | number: '1.0' }}%
      </div>
    </div>

  </section>

  <div *ngIf="moreDetails && quoteStateHelperService.isQuickQuote(this.quoteRequestState)" class="load-profile-and-start-date">
    <div class="flex-row">

    <app-load-profile-input formControlName="utilityRateCode"
                        [quoteRequestId]="this.quoteRequestId"
                        [state]="this.stateCode"
                        [commodity]="this.commodity"
                        [utilityDetails]="this.utilityDetails"
                        [utilityRateCode]="this.utilityRateCode"
                        [shouldBeValidated]="this.shouldLoadProfileBeValidated"                 
                        >
    </app-load-profile-input>

    <app-new-contract-start-month-input formControlName="newContractStartMonth"> </app-new-contract-start-month-input>

  </div>
  </div>
  
</form>

<app-offer-filters
  *ngIf="moreDetails"
  [contractLengths]="this.contractLengths"
  >
</app-offer-filters>
